import { render, staticRenderFns } from "./ServiceTravellersCollapse.vue?vue&type=template&id=cf1d89b4&scoped=true&"
import script from "./ServiceTravellersCollapse.vue?vue&type=script&lang=js&"
export * from "./ServiceTravellersCollapse.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTravellersCollapse.vue?vue&type=style&index=0&id=cf1d89b4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1d89b4",
  null
  
)

export default component.exports